/* eslint-disable react-hooks/exhaustive-deps */
import Map from "./Map";
import NavPageSelector from "../../components/NavPageSelector";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SignInComponent from "../../components/Sign/SignComponent";
import CoordinatesInput from "../../components/CoordinatesInput";
import {
  Autocomplete,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import "./style.css";
import CloseIcon from "@mui/icons-material/Close";
import axios from "../../api/axios_client";
import { url } from "../../api/axios_client";
import ExcelColumnSelector from "./ExcelFileUploader";
import { toast } from "react-toastify";
import MainIndex from "./MainIndex";
import RefIndexComponent from "./RefIndexComponent";
import PredictionResponseComponent from "./PredictionResponseComponent";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  setDetranding,
  setModelName,
  setMultiFeature,
  setSelectedFeaturesColumn,
} from "../../reducers/PredictionSlice";
import Stripe from "../BasePage/Stripe";
import LanguageSwitcher from "../../components/LanguageSwitcher";

const dialogStyle = {
  position: "absolute",
  top: 0,
  right: 0,
  height: "100%",
  width: "100%",
  margin: "0",
  textAlign: 'left',
};

const Index = () => {
  const dispatch = useDispatch();
  const getIndexesFromCategories = () => {
    try {
      const categoriesStr = localStorage.getItem('categories');
      if (!categoriesStr) return [];

      const categories = JSON.parse(categoriesStr);
      // Map categories to required format
      return categories.map(category => ({
        id: category.id,
        name: category.name,
        key: category.name.toLowerCase() // or use category.type if you prefer
      }));
    } catch (error) {
      console.error('Error parsing categories from localStorage:', error);
      return [];
    }
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const indexes = getIndexesFromCategories();

  const rangePairs = useSelector((state) => state.predictionState.rangePairs);
  const values = useSelector((state) => state.predictionState.values);
  const { t } = useTranslation();
  const areas = useSelector((state) => state.mapState.areas);
  const [loading, setloading] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [additionalInformation, setAdditionalInformation] = useState('');
  const [additionalInformationAr, setAdditionalInformationAr] = useState('');

  //   side modal
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (!areas || !areas[0] || !areas[0].coordinates) {
      toast.error("Please select the area you want to be predicted");
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    // dispatch(resetStore());
    setOpen(false);
    setAdditionalInformation('');
    setAdditionalInformationAr('');
    setShowValidation(false);
  };

  //   submit
  const [predictionData, setpredictionData] = useState();

  const validateData = () => {
    // Validate area selection
    if (!areas || !areas[0] || !areas[0].coordinates) {
      toast.error("Please select the area you want to predict");
      return false;
    }

    // Validate prediction name
    if (!predictionName || predictionName.trim() === '') {
      toast.error("Please enter a prediction name");
      return false;
    }

    // Validate column values
    if (!columnValues || columnValues.length === 0) {
      toast.error("Please select the data for prediction");
      return false;
    }

    // Validate added indexes
    if (addedIndexes && addedIndexes.length > 0) {
      for (let i = 0; i < addedIndexes.length; i++) {
        const addedIndex = addedIndexes[i];

        // Validate index is selected
        if (!addedIndex.name || !addedIndex.id) {
          toast.error(`Please select an index for additional index ${i + 1}`);
          return false;
        }

        // Validate date range - UPDATED TO CHECK FOR NUMBERS
        if (typeof addedIndex.current_yearFrom !== 'number' ||
          typeof addedIndex.current_monthFrom !== 'number' ||
          typeof addedIndex.current_dayFrom !== 'number' ||
          typeof addedIndex.current_yearTo !== 'number' ||
          typeof addedIndex.current_monthTo !== 'number' ||
          typeof addedIndex.current_dayTo !== 'number') {
          toast.error(`Please select the date range for additional index ${i + 1}`);
          return false;
        }

        // Validate spatial stats
        if (!addedIndex.spatialStats) {
          toast.error(`Please select spatial stats for additional index ${i + 1}`);
          return false;
        }

        // Validate temporal stats
        if (!addedIndex.temporalStats) {
          toast.error(`Please select temporal stats for additional index ${i + 1}`);
          return false;
        }

        // Validate historical data range
        if (!addedIndex.historical_yearFrom || !addedIndex.historical_yearTo) {
          toast.error(`Please select the historical data range for additional index ${i + 1}`);
          return false;
        }
      }
    }

    // Validate model selection
    if (!modelName) {
      toast.error("Please select a model");
      return false;
    }

    const isValidDate = (date) => {
      if (!date) return false;
      if (typeof date === 'object' && Object.keys(date).length === 0) return false;
      return true;
    };

    // If using reference index (mask), validate mask data
    if (refToggle) {
      if (!refData.maskId && !refData.uploaded) {
        toast.error("Please select or upload a reference index");
        return false;
      }

      // Validate mask date range (only if not using upload)
      if (!uploadMaskToggle && (!isValidDate(refFromDate) || !isValidDate(refToDate))) {
        toast.error("Please select the date range for the masking index");
        return false;
      }

      // Validate mask prediction date range (only if not using single mask and not upload)
      if (!chooseOneMask && !uploadMaskToggle && (!isValidDate(refPredFromDate) || !isValidDate(refPredToDate))) {
        toast.error("Please select the current date range for the masking index");
        return false;
      }

      if (rangePairs.length <= 0 && values.length <= 0) {
        toast.error("Please select range and/or values for masking");
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    try {
      setShowValidation(true);
      if (!validateData()) {
        setloading(false);
        return;
      }
      setloading(true);

      // Create FormData object
      const formData = new FormData();

      // Add the file if mask upload is enabled
      if (uploadMaskToggle && maskingFileContent) {
        formData.append('mask_file', maskingFileContent);
      }

      // Create the JSON payload
      const jsonData = {
        area_name: predictionName,
        y_data: columnValues,
        indices: indexesData,
        mask: {
          ...refData,
          // Remove the actual file from JSON since we're sending it separately
          upload_tif: null
        },
        multiFeatures,
        detranding,
        selectedColumn: selectedColumn || null,
        modelName,
        coords: Array.isArray(areas[0].coordinates) ? areas[0].coordinates : null,
        geo: Array.isArray(areas[0].coordinates) ? null : JSON.stringify(areas[0].coordinates),
        additional_information: additionalInformation || '',
        additional_information_ar: additionalInformationAr || '',
      };

      // Add the JSON data as a string
      formData.append('json_data', JSON.stringify(jsonData));

      const res = await axios.post(`${url}/prediction/prediction`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
      });

      if (res.status === 200) {
        const result = await res.data;
        if (result && result.data) {
          toast.success("Prediction generated successfully");
          setpredictionData(result.data);
        } else {
          toast.error("Something went wrong");
        }
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
    } finally {
      setloading(false);
    }
  };

  // ref index
  const [predictionName, setPredictionName] = useState("");
  const RefIndex = useSelector((state) => state.predictionState.RefIndex);
  const [columnValues, setColumnValues] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const fileContent = useSelector(
    (state) => state.mapState.uploadedFileContent
  );

  const [sliderPage, setsliderPage] = useState({
    file: true,
    main: false,
    ref: false,
    additionalInfo: false,
    result: false,
  });

  const handleRight = () => {
    setsliderPage((prevSliderPage) => {
      let nextSliderPage = { ...prevSliderPage };
      const pages = Object.keys(nextSliderPage);
      const currentPageIndex = pages.findIndex((page) => nextSliderPage[page]);

      if (currentPageIndex === pages.length - 1) {
        return prevSliderPage;
      }

      // Set the current page to false
      nextSliderPage[pages[currentPageIndex]] = false;

      // Otherwise, set the next page to true
      nextSliderPage[pages[currentPageIndex + 1]] = true;
      console.log(sliderPage);

      return nextSliderPage;
    });
  };

  const handleLeft = () => {
    setsliderPage((prevSliderPage) => {
      let nextSliderPage = { ...prevSliderPage };
      const pages = Object.keys(nextSliderPage);
      const currentPageIndex = pages.findIndex((page) => nextSliderPage[page]);

      // Set the current page to false
      nextSliderPage[pages[currentPageIndex]] = false;
      if (currentPageIndex === 0) {
        return prevSliderPage;
      }

      // Otherwise, set the previous page to true
      nextSliderPage[pages[currentPageIndex - 1]] = true;

      return nextSliderPage;
    });
  };

  // y data
  const multiFeatures = useSelector(
    (state) => state.predictionState.multiFeatures
  );
  const detranding = useSelector((state) => state.predictionState.detranding);
  const loadingFeatures = useSelector(
    (state) => state.predictionState.loadingFeatures
  );
  const featuresColumn = useSelector(
    (state) => state.predictionState.featuresColumn
  );
  const selectedColumn = useSelector(
    (state) => state.predictionState.selectedColumn
  );

  const models = [
    { name: "Linear Regression", key: "lr" },
    { name: "Random Forest Regressor", key: "rfr" },
    { name: "Support Vector Regression", key: "svr" },
    { name: "Support Vector Classification", key: "svc" },
    { name: "Random Forest Classifier", key: "rf" },
  ];

  const modelName = useSelector((state) => state.predictionState.modelName)

  const addedIndexes = useSelector(
    (state) => state.predictionState.addedIndexes
  );
  const indexesData = addedIndexes;

  // ref
  const refFromDate = useSelector((state) => state.predictionState.refFromDate);
  const refToDate = useSelector((state) => state.predictionState.refToDate);
  const refToggle = useSelector((state) => state.predictionState.refToggle);
  const chooseOneMask = useSelector((state) => state.predictionState.chooseOneRef);
  const uploadMaskToggle = useSelector((state) => state.predictionState.uploadMaskToggle);
  const maskingFileContent = useSelector((state) => state.mapState.maskingFileContent);
  const refPredFromDate = useSelector((state) => state.predictionState.refPredFromDate);
  const refPredToDate = useSelector((state) => state.predictionState.refPredToDate);

  const refData = {
    maskId: RefIndex[0],
    uploaded: uploadMaskToggle,
    upload_container: uploadMaskToggle ? "mask_container" : null,
    upload_tif: uploadMaskToggle ? maskingFileContent : null,
    range: rangePairs,
    values: values,
    historical_from_date: refFromDate,
    historical_to_date: refToDate,
    current_from_date: refPredFromDate,
    current_to_date: refPredToDate,
    refToggle: refToggle,
    chooseOneMask: chooseOneMask
  };

  const handleFeatureSelect = (event) => {
    const selectedFeatureKey = event.target.value;
    const columnNames = excelData[0] ?? [];

    const rawFeatureValues = fileContent.features.map(
      (feature) => feature.properties[selectedFeatureKey]
    );

    const matchedValues = rawFeatureValues.filter((value) => columnNames.includes(value));

    const keys = {};
    const valuesToUse = matchedValues.length > 0 ? matchedValues : rawFeatureValues;

    valuesToUse.forEach((value) => {
      const colIndex = columnNames.indexOf(value);
      if (colIndex !== -1) {
        keys[value] = excelData.slice(1).map((row) => row[colIndex]);
      }
    });

    setColumnValues([keys]);
    dispatch(setSelectedFeaturesColumn(selectedFeatureKey));
  };

  // ref pred
  return (
    <div className="monitoring-container">
      <div className="map-wrapper">
        {!isMobile && <Stripe>
          <NavPageSelector route={"prediction"} />
          <div className="stripe-content">
            <LanguageSwitcher stripe={true} />
            <SignInComponent
              menuIconColor="black"
              backgroundColor="white"
              classN="modalcontainer-base"
              stripe={true}
            />
          </div>
        </Stripe>}
        <Stripe second={true}>
          <CoordinatesInput disableFileUpload={false} />
          <button className="submit-compare-buttons" onClick={handleOpen}>
            {t('Map.prediction')}
          </button>
        </Stripe>

        {isMobile && <NavPageSelector route={"prediction"} />}


        <Map />

        {/* side modal */}
        <div className="submit-compare-buttons-container">

          <Dialog
            open={open}
            fullScreen
            onClose={handleClose}
            PaperProps={{ sx: dialogStyle, style: { maxHeight: "None" } }}
            dir="ltr"

          >
            <DialogContent>
              {/* Content of your side modal goes here */}
              <CloseIcon
                sx={{
                  cursor: "pointer",
                  position: "absolute",
                  right: "15px",
                  color: "#329ace",
                }}
                onClick={handleClose}
              />

              {/* Excel  */}
              <br />
              <br />
              <div className="pred-right-arrow" onClick={handleRight}>
                <span>Next</span> <ArrowForwardIosIcon />
              </div>
              <div className="pred-left-arrow" onClick={handleLeft}>
                <ArrowBackIosIcon /> <span>Previous</span>
              </div>

              {/* file selection */}
              <div
                style={{
                  display: sliderPage.file ? "flex" : "none",
                }}
                className="pred-file-choosing-container"
              >
                <div>
                  <TextField
                    label="Prediction Name"
                    variant="outlined"
                    fullWidth
                    value={predictionName}
                    onChange={(e) => setPredictionName(e.target.value)}
                    style={{ marginBottom: "1em" }} // Add some margin for spacing
                  />
                  <ExcelColumnSelector
                    setColumnValues={setColumnValues}
                    excelData={excelData}
                    setExcelData={setExcelData}
                    multiFeatures={multiFeatures}
                  />
                  <br />
                  {excelData.length > 0 ? (<FormControlLabel
                    sx={{
                      marginBottom: "1em",
                    }}
                    control={
                      <Switch
                        checked={multiFeatures}
                        onChange={() => dispatch(setMultiFeature())}
                        color="primary" // You can change the color if needed
                      />
                    }
                    label="Multi Features"
                  />) : (<div></div>)}
                  {!multiFeatures ? (
                    <div></div>
                  ) : loadingFeatures ? (
                    <CircularProgress />
                  ) : (
                    <div style={{ marginBottom: "2em" }}>
                      <InputLabel id={"feature-columns"}>
                        Attributes Column
                      </InputLabel>
                      <Select
                        fullWidth
                        size="small"
                        labelId={"feature-columns"}
                        id={"feature-columns-select"}
                        onChange={handleFeatureSelect}
                      >
                        {featuresColumn.map((stat, statIndex) => {
                          return (
                            <MenuItem key={statIndex} value={stat}>
                              {stat}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  )}
                  <br />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={detranding}
                        onChange={() => dispatch(setDetranding())}
                        color="primary" // You can change the color if needed
                      />
                    }
                    label="Predict for the detrended data"
                  />
                  <div>
                    <br />
                    <Typography fontWeight={600}>Choose a prediction model</Typography>
                    <br />
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      isOptionEqualToValue={(option, value) =>
                        option.name === value.name
                      } // Compare only "name" properties
                      getOptionLabel={(option) => (option ? option.name : "")}
                      onChange={(_, selected) => {
                        console.log(selected);
                        dispatch(setModelName(selected.key));
                      }}
                      options={models || []}
                      sx={{ width: "100%%" }}
                      renderInput={(params) => (
                        <TextField {...params} label="Model" />
                      )}
                    />
                  </div>
                  <br />
                  <Typography sx={{ opacity: 0.5 }} fontSize={12}>
                    Note that for classification models, the training values must be <b>integers</b> representing each class.
                  </Typography>
                </div>
              </div>
              {/* main index */}
              <div
                className="pred-big-container"
                style={{
                  display: sliderPage.main ? "flex" : "none",
                }}
              >
                <div className="pred-main-container">
                  <MainIndex indexes={indexes} showValidation={showValidation} />
                </div>
                <br />
              </div>
              {/* mask selection ? */}
              <div
                style={{
                  display: sliderPage.ref ? "flex" : "none",
                }}
                className="pred-main-container"
              >
                {/* Ref index */}
                <RefIndexComponent indexes={indexes} refToggle={refToggle} showValidation={showValidation} />
              </div>
              {/* prediction selection */}
              {sliderPage.pred && (
                <div
                  style={{
                    display: sliderPage.pred ? "flex" : "none",
                  }}
                  className="pred-main-container"
                >
                  <br />
                </div>
              )}
              {/* Additional Information page */}
              <div
                style={{
                  display: sliderPage.additionalInfo ? "flex" : "none",
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                className="pred-main-container"
              >
                <div style={{ width: '100%', padding: '20px' }}>
                  <Typography variant="h6" gutterBottom>
                    Additional Information
                  </Typography>

                  <TextField
                    label="Additional Information"
                    multiline
                    rows={7}
                    fullWidth
                    variant="outlined"
                    value={additionalInformation}
                    onChange={(e) => setAdditionalInformation(e.target.value)}
                    placeholder="Enter any additional information..."
                    inputProps={{ maxLength: 2000 }}
                    style={{ marginBottom: '20px' }}
                    helperText={`${additionalInformation.length}/2000`}
                  />

                  <TextField
                    label="معلومات إضافية"
                    multiline
                    rows={7}
                    fullWidth
                    variant="outlined"
                    value={additionalInformationAr}
                    onChange={(e) => setAdditionalInformationAr(e.target.value)}
                    placeholder="أدخل أي معلومات إضافية..."
                    inputProps={{ maxLength: 2000, dir: 'rtl' }}
                    style={{ marginBottom: '20px' }}
                    helperText={`${additionalInformationAr.length}/2000`}
                  />
                </div>
              </div>
              <div
                style={{
                  display: sliderPage.result ? "flex" : "none",
                }}
                className="pred-main-container"
              >
                {/* response table */}
                <PredictionResponseComponent
                  predictionResponse={predictionData}
                />

                {/* submit btn */}
                <div>
                  {loading ? (
                    <CircularProgress />
                  ) : (
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={handleSubmit}
                      className="submit-compare-buttons"
                      disabled={false}
                    // TODO: change disabled to function
                    >
                      {t("submit")}
                    </Button>
                  )}
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </div>
  );
};

export default Index;
